import React from 'react';
import styled from '@emotion/styled';
import { Text, Flex } from 'basis';
import { isDJ } from 'utils/byConfig';

const getOrderColor = props => (isDJ() ? 'black' : props.theme?.colors?.indigo || '#0b2374');

const Order = styled.div`
  border-radius: 50%;
  text-align: center;
  background-color: ${getOrderColor};
  color: white;
  width: 24px;
  line-height: 24px;
  margin-right: 12px;
  height: 24px;
  flex-shrink: 0;
`;

export const AusPostAction = ({ order, children }) => {
  return (
    <Flex>
      <Order>{order}</Order>
      <Text>
        <strong>{children}</strong>
      </Text>
    </Flex>
  );
};
